import {
     ADD_NOTIFICATION_TEMPLATE,
     GET_NOTIFICATION_TEMPLATE,
     ALL_NOTIFICATION_TEMPLATE,
     EDIT_NOTIFICATION_TEMPLATE
  } from "./actionTypes"
  
  export const addNotificationTemplate = (template,history) => {
    return {
      type: ADD_NOTIFICATION_TEMPLATE,
      payload: { template,history},
    }
  }

  export const getNotificationTemplate = (data) => {
    return {
      type: GET_NOTIFICATION_TEMPLATE,
      payload: { data},
    }
  }

  export const allNotificationTemplate = template => {
    return {
      type: ALL_NOTIFICATION_TEMPLATE,
      payload: template,
    }
  }

  export const editNotificationTemplate = (template,history) => {
    return {
      type: EDIT_NOTIFICATION_TEMPLATE,
      payload:{template,history},
    }
  }